import {React,useState} from 'react'
import { Container,Row,Col,Form,FormGroup } from 'react-bootstrap'
import Helmet from '../components/Helmet/Helmet'
import { Link } from 'react-router-dom'
import {createUserWithEmailAndPassword , updateProfile} from 'firebase/auth'
import {ref,uploadBytesResumable,getDownloadURL} from 'firebase/storage'
import { auth } from '../firebase.config'
import { db } from '../firebase.config'
import { storage } from '../firebase.config'
import { setDoc , doc } from 'firebase/firestore'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
import '../assets/style/login.css'


const Signup = () => {

    const navigate = useNavigate();
    const [username,setUsername] = useState('');
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [file,setFile] = useState(null)
    const [loading,setLoading] = useState(false)

    const register = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            const storageRef = ref(storage, `images/${user.uid}/${file.name}`);
            const snapshot = await uploadBytesResumable(storageRef, file, 'data_url');
            
            const downloadURL = await getDownloadURL(snapshot.ref);
            
            await updateProfile(user, {
                displayName: username,
                photoURL: downloadURL,
            });
            
            await setDoc(doc(db, 'users', user.uid), {
                uid: user.uid,
                displayName: username,
                email,
                photoURL: downloadURL,
            });
            
            setLoading(false);
            toast.success('Account created successfully');
            navigate('/login');
        } catch (error) {
            setLoading(false);
            toast.error('Something went wrong. Please try again.');
            }
        }
    



    return (
        <>
            <Helmet title='Signup'/>
            <section>
                <Container>
                    <Row>
                        {
                            loading ? <Col lg='12' className='text-center'>
                                    <h6 className='fw-bold'>Loading....</h6>
                                </Col> 
                            :
                            <Col lg='6' className='m-auto text-center'>
                                <h3 className='fw-bold mb-4'>Sign Up</h3>

                                <Form className='auth__form' >
                                    <FormGroup className='form__group'>
                                        <input value={username} onChange={(e)=>setUsername(e.target.value)} type="text" placeholder='Username' />
                                    </FormGroup>
                                    <FormGroup className='form__group'>
                                        <input value={email} onChange={(e)=>setEmail(e.target.value)} type="email" placeholder='Email' />
                                    </FormGroup>
                                    <FormGroup className='form__group'>
                                        <input value={password} onChange={(e)=>setPassword(e.target.value)} type="password" placeholder='Password' />
                                    </FormGroup>
                                    
                                    <FormGroup className='form__group'>
                                        <input type="file" onChange={(e)=>setFile(e.target.files[0])}  />
                                    </FormGroup>
                                    <button onClick={register} type='submit' className='buy__btn auth__btn'>Sign Up</button>
                                    <p>Already have an account? <Link to='/login'>Login</Link></p>
                                </Form>

                            </Col>
                        }
                        <Col lg='6'>

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Signup